import { useEffect, useState } from 'react';
import { DelayedSwitch } from 'components/utils/Switch';
import InformationIcon from 'components/utils/iconComponents/InformationIcon';

const NewModalAlwaysWin = ({ handlerAlwaysWin, product }) => {
  const INFORMATION_WIN =
    'Incluso cuando estés ganando, modificaremos el precio si encontramos oportunidades de obtener un mayor margen de ganancias para ti usando nuestro modelo de análisis del mercado';

  const [isActive, setIsActive] = useState(
    product.currentBid ? product.currentBid?.maximizeEarningMargin : false
  );

  useEffect(() => {
    handlerAlwaysWin(isActive);
  }, [isActive]);

  const handlerActiveSwitch = () => {
    setIsActive((prevState) => !prevState);
  };

  //TODO si esta desactivado valida por price to win sino price to win y ampliar margen para seguir ganando.

  return (
    <div className='flex justify-between border border-gray-300 py-[10px] px-[18px] rounded-lg mt-8 items-center'>
      <span className='text-base font-semibold text-gray-700'>
        Permitir a Atibo realizar cambios para maximizar ganancias
      </span>
      <span className='flex justify-end cursor-pointer h-[25px] pr-4'>
        <InformationIcon title={INFORMATION_WIN} color='#6941C6'/>
      </span>
      <span className='flex py-0 ml-1'>
        <DelayedSwitch
          id='alwaysWin'
          name='alwaysWin'
          value={true}
          onChange={handlerActiveSwitch}
          checked={isActive}
        />
      </span>
    </div>
  );
};

export default NewModalAlwaysWin;
